import { render, staticRenderFns } from "./CourseComment.vue?vue&type=template&id=77fae380&scoped=true&"
import script from "./CourseComment.vue?vue&type=script&lang=js&"
export * from "./CourseComment.vue?vue&type=script&lang=js&"
import style0 from "./CourseComment.vue?vue&type=style&index=0&id=77fae380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fae380",
  null
  
)

export default component.exports